import { getConfig } from '@/config'
import { resolveLineCode } from '@/utils/channel'

let loaded = false

function loadCrispScript(id) {
  window.$crisp = window.$crisp || []
  window.CRISP_WEBSITE_ID = id
  const script = document.createElement('script')
  script.src = 'https://client.crisp.chat/l.js'
  script.async = true
  document.head.appendChild(script)
}

/**
 * 在落地页加载 Crisp 客服，并把访客来源（代理线 + 落地页域名）标注到会话上。
 * 未配置 crispWebsiteId 时不加载。
 */
export function initCrisp() {
  if (loaded) return
  const id = String(getConfig().crispWebsiteId || '').trim()
  if (!id) return
  loaded = true

  const line = resolveLineCode() || 'default'
  const host = (typeof location !== 'undefined' && location.host) || 'unknown'

  const applySession = () => {
    const api = window.$crisp
    if (!api || typeof api.set !== 'function') return
    api.set('session:segments', [['agent_line', line]])
    api.set('session:data', [['代理线', line], ['落地页', host]])
    api.set('session:event', [['agent_source', { 代理线: line, 落地页: host }, 'blue']])
  }

  window.$crisp = window.$crisp || []
  window.$crisp.push(['set', 'session:segments', [['agent_line', line]]])
  window.$crisp.push(['set', 'session:data', [['代理线', line], ['落地页', host]]])
  window.$crisp.push(['set', 'session:event', [['agent_source', { 代理线: line, 落地页: host }, 'blue']]])
  window.$crisp.push(['on', 'session:loaded', applySession])

  loadCrispScript(id)
}
